<i18n locale="en">
{
  "label": "Coupon",
  "placeholder": "Search for coupon",
  "no-data": "No coupons found",
  "errors": {
    "load": "Unable to load coupons"
  },
  "types": {
    "item": "Item",
    "ticket": "Ticket"
  }
}
</i18n>

<template>
  <MenuResourceSelector
    v-model="couponId"
    class="coupon-selector"
    :fetch-handler="getCoupons"
    :label="$t('label')"
    :placeholder="$t('placeholder')"
    :location="location"
    :limit="limit"
    :allow-deselect="allowDeselect"
  >
    <template #no-data>
      <NoDataCard :title="$t('no-data')" />
    </template>
    <template #menu-item="{ menuItem }">
      <OwnStack class="pa-4" spacing="1">
        <h3 class="text-subtitle-1" v-text="menuItem.displayName"></h3>
        <p
          class="text-paragraph text-color-secondary"
          v-text="getCouponDescription(menuItem)"
        ></p>
      </OwnStack>
    </template>
  </MenuResourceSelector>
</template>

<script>
import { couponsApi2 } from '@/api'

import notify from '@/mixins/notify'

import { OwnStack } from '@/ui'

import { mapModel } from '@/utils/computed'
import { formatNumberValue } from '@/utils/helpers'

import MenuResourceSelector from '../components/menu-resource-selector/MenuResourceSelector.vue'
import NoDataCard from '../components/menu-resource-selector/NoDataCard.vue'

export default {
  name: 'CouponSelector',
  components: {
    MenuResourceSelector,
    NoDataCard,
    OwnStack,
  },
  mixins: [notify],
  props: {
    /** Whether to allow the user to deselect an item by clicking */
    allowDeselect: { type: Boolean, default: false },

    /** Maximum items to show in the list */
    limit: { type: [String, Number], default: '10' },

    /** The ID of the location to search under */
    location: { type: [String, null], default: null },

    /**
     * @model
     *
     * The Coupon ID
     */
    value: { type: String, default: null },
  },
  computed: {
    ...mapModel('couponId'),
  },
  methods: {
    getCouponDescription(coupon) {
      return `${this.getCouponType(coupon)}, ${this.getCouponValue(coupon)}`
    },
    getCouponType(coupon) {
      const type = ['ticket-percent', 'ticket-fixed'].includes(coupon.type)
        ? 'ticket'
        : 'item'

      return this.$t(`types.${type}`)
    },
    getCouponValue(coupon) {
      const amountFormat = ['item-fixed', 'ticket-fixed'].includes(coupon.type)
        ? 'currency'
        : 'percentage'

      return formatNumberValue(coupon.amount, amountFormat)
    },
    async getCoupons(filter) {
      try {
        return await couponsApi2.getGroup(filter)
      } catch (error) {
        this.$notify(this.$t('errors.load'), 'error')
      }
    },
  },
}
</script>
